import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  isOpen = false
}: AccordionItemProps) {
  const [open, setOpen] = useState(isOpen);
  return <div className="border border-slate-700 rounded-xl mb-4 bg-slate-900 overflow-hidden transition-all duration-200 hover:border-blue-500/50" data-id="element-179">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-180">
        <span className="font-semibold text-white pr-4" data-id="element-181">{title}</span>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 flex-shrink-0 ${open ? 'rotate-180' : ''}`} data-id="element-182" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${open ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-183">
        <div className="text-slate-400 leading-relaxed" data-id="element-184">{children}</div>
      </div>
    </div>;
}